<div class="container container_type_main-page">

  <app-hit-melodies [melodies]="hitsMelodies" [showSubtitle]="true"></app-hit-melodies>

  <div class="subtitle">
    <div class="h2">{{ 'main-page.genres-music' | translate }}</div>
    <div class="subtitle__link">
      <a routerLink="/genres" class="subtitle__link-link">
        <span class="subtitle__link-link-desktop">{{ 'main-page.more-music' | translate }}</span>
        <span class="subtitle__link-link-mobile">{{ 'main-page.all' | translate }}</span></a>
    </div>
  </div>

  <app-genres-slider></app-genres-slider>

  <div class="subtitle">
    <div class="h2">{{ 'main-page.new-music' | translate }}</div>
    <div class="subtitle__link">
      <a routerLink="/genres" class="subtitle__link-link">
        <span class="subtitle__link-link-desktop">{{ 'main-page.more-music' | translate }}</span>
        <span class="subtitle__link-link-mobile">{{ 'main-page.all' | translate }}</span></a>
    </div>
  </div>

  <div class="songs-list">
    <div *ngFor="let melody of newMelodies" class="songs-list__item" app-melody-item [melody]="melody"></div>
  </div>

  <app-privet-plus-banner [specialBanners] = "mainPageSpecialBanners"></app-privet-plus-banner>

  <div class="subtitle">
    <div class="h2">{{ 'main-page.popular-music' | translate }}</div>
    <div class="subtitle__link">
      <a routerLink="/genres" class="subtitle__link-link">
        <span class="subtitle__link-link-desktop">{{ 'main-page.more-music' | translate }}</span>
        <span class="subtitle__link-link-mobile">{{ 'main-page.all' | translate }}</span></a>
    </div>
  </div>

  <div class="songs-list">
    <div *ngFor="let melody of popularMelodies" class="songs-list__item" app-melody-item [melody]="melody"></div>
  </div>
</div>

<app-main-page-banner [banners] = "mainPageBanners"></app-main-page-banner>

<div class="container container_type_main-page">
  <app-main-page-subscription-select [privet]="privet" [privetPlus]="privetPlus" *ngIf="!privet || !privetPlus"></app-main-page-subscription-select>

  <app-mobile-apps-banner></app-mobile-apps-banner>
</div>
